import { api } from '../DefaultService';
import { ISchoolPerimeterStatusResponse, IRecognitionFilter } from './types';

const ENDPOINT = 'v1/recognitions/school-perimeter';

export const getSchoolPerimeterStatusAsync = async (
  filter?: IRecognitionFilter,
): Promise<ISchoolPerimeterStatusResponse> => {
  return await api
    .get(ENDPOINT, {
      params: {
        search: filter?.search,
        discriminator: filter?.discriminator,
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro ao buscar status do perímetro!',
      );
    });
};